/**
 * Convert a string of HTML into a Virtual DOM element to use.
 *
 * @example
 * ```ts
 * const htmlString = '<div>Hello World</div>';
 * const virtualDom = stringToDom(htmlString);
 * console.log(virtualDom); // Outputs a Virtual DOM representation of the HTML string
 * ```
 *
 * @param htmlString The HTML string to convert.
 * @returns A Virtual DOM element representing the HTML.
 */
export function stringToDom(htmlString: string): DocumentFragment {
  const template = document.createElement('template');
  template.innerHTML = htmlString.trim();
  return template.content;
}
